
namespace TabAurous.OMS {
    import fld = ProductSequenceRow.Fields;
    @Serenity.Decorators.registerClass()
    export class ProductSequenceEditor extends _Ext.ItemGridEditor<ProductSequenceRow> {
        protected getColumnsKey() { return 'OMS.ProductSequence'; }
        protected getDialogType() { return ProductSequenceDialog; }
        protected getLocalTextPrefix() { return ProductSequenceRow.localTextPrefix; }

        private pendingChanges: Q.Dictionary<any> = {};

        constructor(container: JQuery) {
            super(container);
        }

        protected getButtons() {
            let buttons = super.getButtons();
            buttons = buttons.filter(x => x.cssClass != "add-button");
            //**** Master ****//
            buttons.push({
                title: "Select Sequence",
                cssClass: "stock-button",
                hotkey: "alt+k",
                hint: 'alt+k',
                onClick: () => {
                    var grid = Administration.SequenceSelectGrid;
                    // **** Validate Party before Item Selection ****  
                    var filters: _Ext.SelectGridFilters = {

                    }

                    var pickerDialog = new _Ext.GridItemPickerDialog({
                        gridType: grid, multiple: false, title: "Select Sequence"
                    });

                    pickerDialog.onSuccess = (selectedItems: Administration.SequenceRow[]) => {
                        let selectedItems2 = selectedItems[0];
                        this.view.setItems([]);
                        for (var i = 0; i < selectedItems2.Processes.length; i++) {
                            var Seq = selectedItems2.Processes[i];
                            var newSeq: ProductSequenceRow = {
                                DepartmentId: Seq.DepartmentId,
                                ProcessId: Seq.ProcessId,
                                ProcessName: Seq.ProcessName,
                                DeptName: Seq.DeptName,
                                MaxLoss: 0,
                                StdLoss: 0,
                                Complexity: 0,
                                Priority: Seq.Priority
                            }
                            newSeq[this.getIdProperty()] = "`" + this.nextId++;
                            this.view.addItem(newSeq);
                        }
                    }

                    pickerDialog.dialogOpen();
                },
            });
            return buttons;
        }

        protected getColumns() {

            var columns = super.getColumns();
            //var num = ctx => ColumnFormatter.numericInputFormatter(ctx, this);
            //var int = ctx => ColumnFormatter.integerInputFormatter(ctx, this);


            //Q.first(columns, x => x.field === fld.MaxLoss).format = num;
            //Q.first(columns, x => x.field === fld.StdLoss).format = num;
            //Q.first(columns, x => x.field === fld.Complexity).format = int;


            columns.unshift({
                field: 'Delete Row',
                name: '',
                format: ctx => '<a class="inline-action delete-row" title="delete">' +
                    '<i class="fa fa-trash-o text-red"></i></a>',
                width: 24,
                minWidth: 24,
                maxWidth: 24
            });

            //this.view.refresh();
            return columns;
        }

    }
}